import { createFileRoute } from '@tanstack/react-router'
import { PayslipPage } from '../../../../../../features/payroll/payslip-page'

export const Route = createFileRoute('/_app/payroll/runs/$runId/payslips/$payslipId')({
  staticData: { crumb: 'payrollPayslip' },
  component: PayslipPage,
})
